import { PeriodPager } from '@/components/common/PeriodPager'

type Props = {
  year: number
  minYear: number
  maxYear: number
  onChange: (nextYear: number) => void
  testIdPrefix?: string
}

export function YearPager({ year, minYear, maxYear, onChange, testIdPrefix }: Props) {
  return (
    <PeriodPager
      label={year}
      previousLabel="Vorheriges Jahr"
      nextLabel="Nächstes Jahr"
      onPrevious={() => onChange(Math.max(minYear, year - 1))}
      onNext={() => onChange(Math.min(maxYear, year + 1))}
      previousDisabled={year <= minYear}
      nextDisabled={year >= maxYear}
      testIdPrefix={testIdPrefix}
    />
  )
}
